import { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { GeneralDropdown } from "../../../../components/components/js/GeneralDropdown";
import { downloadPDF } from "../../../../utils/exportUtils";
import { IndividualReport } from "./IndividualReport";
// Comparative Report is disabled — see note below.
// import { ComparativeReport } from "./ComparativeReport";
import { useTranslation } from "react-i18next";

export const QuranReport = () => {
  const { t } = useTranslation();
  const trans_prefix = "admin_pages.quran_report";
  const trans = {
    title: t("admin_titles.quran_report"),
    export_pdf: t("buttons.export_pdf"),
    individual_report: t(`${trans_prefix}.report_types.individual`),
    comparative_report: t(`${trans_prefix}.report_types.comparative`),
  };

  // Comparative Report is disabled for the V2 migration: there is no
  // "comparison"-equivalent endpoint anywhere in the V2 Postman collection
  // (V1 hit /en/api/nursery/comaprison/). This is a confirmed backend gap,
  // not a renamed endpoint — re-enable once backend adds a V2 endpoint for
  // it. (Individual Report is the only option for now, same as it was at
  // one point in the V1 history.)
  const reportTypes = [
    { value: "individual", label: trans.individual_report },
    // { value: "comparative", label: trans.comparative_report },
  ];

  const getInitialReportType = () => {
    // if there it's in the hash, get it, else, get the first one in the reportTypes array
    const hash = window.location.hash.replace("#", "");
    return reportTypes.find(r => r.value === hash) || reportTypes[0];
  };

  const [selectedReportType, setSelectedReportType] = useState(getInitialReportType);
  const individualReportRef = useRef();
  const comparativeReportRef = useRef();

  const handleReportTypeChange = (option) => {
    setSelectedReportType(option);

    // Update the hash when the user selects a report
    window.location.hash = option.value;
  };

  const handleDownloadPDF = () => {
    let element = individualReportRef?.current;
    if (selectedReportType.value === "comparative") {
      element = comparativeReportRef?.current;
    }
    downloadPDF(element);
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-4">
        <div className="d-flex gap-4">
          <h3>{trans.title}</h3>
          <GeneralDropdown
            placeholder={"Report Type"}
            options={reportTypes}
            selectedOption={selectedReportType}
            onChange={handleReportTypeChange}
            backgroundColor={"#eee"}
            width={"11rem"}
            noBorder
          />
        </div>
        <Button
          onClick={handleDownloadPDF}
          className="fw-bold purple-text-color bg-transparent border-0 no-hover-bg"
        >
          {trans.export_pdf}
        </Button>
      </div>

      {selectedReportType.value === "individual" ? (
        <IndividualReport reportRef={individualReportRef} />
      ) : null}
    </>
  );
};